import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import Img from '@UI/Img'
import style from './style.module.less'

@inject('decorationStore')
@observer
export default class extends Component {
  render() {
    const { cover_path, mode } = this.props

    const imgStyle = {
      width: 127,
      height: 169
    }

    const isFake = mode === 'fake'

    return (
      <div className={style.item}>
        {isFake ? (
          <div style={imgStyle} className={style.content} />
        ) : (
          <Img
            src={cover_path}
            className={style.content}
            style={{
              ...imgStyle,
              verticalAlign: 'middle'
            }}
          />
        )}
      </div>
    )
  }
}
